export default __webpack_public_path__ + "static/media/help-rav-qa-6.e23989fe.png";